import { render, staticRenderFns } from "./selector.vue?vue&type=template&id=024fad66&scoped=true&"
import script from "./selector.vue?vue&type=script&lang=js&"
export * from "./selector.vue?vue&type=script&lang=js&"
import style0 from "./selector.vue?vue&type=style&index=0&id=024fad66&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024fad66",
  null
  
)

export default component.exports